import React, { useEffect, useState } from "react";
import { media } from "styled-bootstrap-grid";
import Container from "src/components/UI/Grid/Container";
import Grid from "src/components/UI/Grid/Grid";
import Column from "src/components/UI/Grid/Column";
import Flex from "src/components/UI/Structure/Flex";
import Text from "src/components/UI/Text";
import EventItem from "src/components/Modules/Events/EventItem";
import EventItemSmall from "src/components/Modules/Events/EventItemSmall";
import ListItemStyles from "src/components/styles/ListItemStyles";
import Link from "src/components/UI/Link";

import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { css } from "styled-components";

const transitions = css`
  margin: 0
    ${(props) => (props.size === "small" ? `-${props.theme.space[4]}` : 0)};

  ${media.md`
    margin: 0;
  `}

  .list-appear {
    transform: translateY(35px);
    opacity: 0;
  }
  .list-appear-active {
    transform: translateY(0);
    opacity: 1;
    transition: transform 0.3s ease, opacity 0.5s linear;
  }
`;

const Events = ({ events, label, readMore, size }) => {
  const [clientSideLoaded, setClientSideLoaded] = useState(false)

  useEffect(() => {
    if(typeof document !== 'undefined'){
      setClientSideLoaded(true)
    }
  },[])
  return (
    <div css={transitions} key={label} size={size}>
      <ReactCSSTransitionGroup
        transitionName="list"
        transitionAppear={true}
        transitionAppearTimeout={500}
        transitionEnter={false}
        transitionLeave={false}
      >
        <Container px={size === "small" ? [0] : [0, null, null, 4]}>
          {label && (
            <ListItemStyles
              sticky={size === "small" ? false : true}
              size={size}
              label={1}
            >
              <Grid>
                <Column width={[12 / 12]}>
                  <div className="list-content list-content--label">
                    {label}
                  </div>
                </Column>
              </Grid>
            </ListItemStyles>
          )}
          <div style={{opacity: clientSideLoaded ? 1 : 0}}>
            {!clientSideLoaded && events &&
              events.map((event, i) => {
                const data = event && event.acfEventPage
                const id = data && data.artist && data.artist.id
                const date = data && data.date

                if (size === "small") {
                  return <EventItemSmall key={`${`${id}-${i}`}`} event={event} size={size} />;
                } else {
                  return <EventItem key={`${id}-${i}`} event={event} size={size} />;
                }
            })}
              {clientSideLoaded && events &&
                events.map((event, i) => {
                  const data = event && event.acfEventPage
                  const id = data && data.artist && data.artist.id
                  const date = data && data.date

                  if (size === "small") {
                    return <EventItemSmall key={`${`${id}-${date}`}`} event={event} size={size} />;
                  } else {
                    return <EventItem key={`${id}-${date}`} event={event} size={size} />;
                  }
              })}
          </div>
          {readMore && (
            <ListItemStyles
              sticky={size === "small" ? false : true}
              size={size}
              label={readMore}
            >
              <Link to={readMore.url}>
                <div className="list-content list-content--label">
                  <Flex
                    width={[12 / 12]}
                    justifyContent={[
                      "center",
                      null,
                      null,
                      null,
                      "space-between",
                    ]}
                  >
                    <Text pr={2}>{readMore.text}</Text>
                    <Text>→</Text>
                  </Flex>
                </div>
              </Link>
            </ListItemStyles>
          )}
        </Container>
      </ReactCSSTransitionGroup>
    </div>
  );
};

export default Events;
